import { motion } from 'framer-motion';
import { NamesStyles } from '../../../styles/styles';
import { Animations } from '../../../utils/animations';

//animations
const titleParent = {
  hidden: {
    opacity: 1,
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 2.8,
    },
  },
};

const titleParent2 = {
  hidden: {
    opacity: 1,
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 3.3,
    },
  },
};

const titleTextReveal = {
  hidden: {
    y: '120vh',
  },
  show: {
    y: '0vh',
  },
};

const Names = () => {
  const shaquille = ['S', 'h', 'a', 'q', 'u', 'i', 'l', 'l', 'e'];
  const ndunda = ['N', 'd', 'u', 'n', 'd', 'a'];
  const { transition } = Animations();

  return (
    <NamesStyles>
      <motion.ol
        className="name-wrapper"
        variants={titleParent}
        initial="hidden"
        animate="show">
        {shaquille.map((letter, index) => {
          return (
            <motion.li
              key={index}
              variants={titleTextReveal}
              transition={{ ...transition, duration: 1 }}>
              {letter}
            </motion.li>
          );
        })}
      </motion.ol>
      <motion.ol
        className="name-wrapper"
        variants={titleParent2}
        initial="hidden"
        animate="show">
        {ndunda.map((letter, index) => {
          return (
            <motion.li
              key={index}
              variants={titleTextReveal}
              transition={{ ...transition, duration: 1 }}>
              {letter}
            </motion.li>
          );
        })}
      </motion.ol>
    </NamesStyles>
  );
};

export { Names };
